<div class="my-requests-wrapper" [ngClass]="{ 'dark-theme': isDarkMode() }">
  <div class="module-container">
    <div class="filters-card">
      <form [formGroup]="filterForm">
        <div class="filter-row">
          <div class="filter-item">
            <app-custom-date-picker [label]="'From Date'"
              [controlname]="this.filterForm.controls['from_date']"></app-custom-date-picker>
          </div>
          <div class="filter-item">
            <app-custom-date-picker [label]="'To Date'"
              [controlname]="this.filterForm.controls['to_date']"></app-custom-date-picker>
          </div>
          <div class="filter-btn-container">
            <button class="premium-btn primary" (click)="onDownloadClick()">
              <mat-icon>file_download</mat-icon> Download List
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="table-container-card">
      <div class="table-scroll">
        <table mat-table [dataSource]="dataSource" matSort class="premium-table">
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
            <td mat-cell *matCellDef="let element"> {{element.sno}} </td>
          </ng-container>

          <ng-container matColumnDef="vessel Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Vessel Name </th>
            <td mat-cell *matCellDef="let element" class="vessel-cell">
              {{element['vessel Name']}}
            </td>
          </ng-container>

          <ng-container matColumnDef="port Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Port Name </th>
            <td mat-cell *matCellDef="let element"> {{element['port Name']}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{element.date}} </td>
          </ng-container>

          <ng-container matColumnDef="Frequency">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Freq </th>
            <td mat-cell *matCellDef="let element"> {{element.Frequency}} </td>
          </ng-container>

          <ng-container matColumnDef="Number of Days">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Days </th>
            <td mat-cell *matCellDef="let element"> {{element['Number of Days']}} </td>
          </ng-container>

          <ng-container matColumnDef="file Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Report File </th>
            <td mat-cell *matCellDef="let element" class="file-cell">
              <span class="truncate-file" [matTooltip]="element['file Name']">{{element['file Name']}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let element">
              <div class="status-cell-content">
                <button
                  *ngIf="element.status === 'ready' || element.status === 'completed' || element.status === 'ready to download'"
                  class="download-btn-premium" (click)="onStatusClick(element)">
                  <mat-icon>file_download</mat-icon>
                </button>
                <div
                  *ngIf="element.status !== 'ready' && element.status !== 'completed' && element.status !== 'ready to download'"
                  [class]="getStatusBadgeClass(element.status)">
                  {{ element.status | titlecase }}
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <!-- SKELETON LOADER ROWS -->
          <ng-container *ngIf="isLoadingTable">
            <tr *ngFor="let dummy of [1, 2, 3, 4, 5, 6, 7, 8]" class="mat-row premium-row skeleton-row">
              <td class="mat-cell"><div class="skeleton-bar sno-skeleton"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar"></div></td>
              <td class="mat-cell"><div class="skeleton-bar status-skeleton"></div></td>
            </tr>
          </ng-container>

          <!-- REAL DATA ROWS -->
          <ng-container *ngIf="!isLoadingTable">
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="premium-row"></tr>
          </ng-container>
        </table>

        <div class="no-data-placeholder" *ngIf="!isLoadingTable && dataSource.data.length === 0">
          <mat-icon>assignment_late</mat-icon>
          <p>No reports found.</p>
        </div>
      </div>

      <mat-paginator [pageSizeOptions]="[10, 25, 50]" [pageSize]="10" showFirstLastButtons
        class="premium-paginator"></mat-paginator>
    </div>
  </div>
</div>